import { render, staticRenderFns } from "./wasteEntry.vue?vue&type=template&id=c75032fa&scoped=true"
import script from "./wasteEntry.vue?vue&type=script&lang=js"
export * from "./wasteEntry.vue?vue&type=script&lang=js"
import style0 from "./wasteEntry.vue?vue&type=style&index=0&id=c75032fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75032fa",
  null
  
)

export default component.exports